<section class="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-3">
  <div class="d-flex flex-column gap-1">
    <p class="av-section-hint m-0">{{ 'backoffice.dashboard.intro' | translate }}</p>
    <p class="av-meta m-0">{{ 'backoffice.dashboard.scope_note' | translate }}</p>
  </div>

  <button type="button" class="av-btn" (click)="reload()">
    <mat-icon aria-hidden="true">refresh</mat-icon>
    {{ 'backoffice.common.actions.refresh' | translate }}
  </button>
</section>

<section class="metric-grid d-grid gap-3">
  <av-metric-tile
    [label]="'backoffice.dashboard.tiles.organizations.label' | translate"
    icon="corporate_fare"
    [value]="facade.organizationsTotal().toString()"
    [caption]="
      'backoffice.dashboard.tiles.organizations.caption'
        | translate
          : {
              active: facade.organizationsActive(),
              suspended: facade.organizationsSuspended(),
              cancelled: facade.organizationsCancelled(),
            }
    "
    [state]="facade.organizationsState()"
    [source]="sources['organizations']"
  ></av-metric-tile>

  <av-metric-tile
    [label]="'backoffice.dashboard.tiles.active.label' | translate"
    icon="verified"
    [value]="facade.organizationsActive().toString()"
    [caption]="'backoffice.dashboard.tiles.active.caption' | translate"
    [state]="facade.statusSplitState()"
    [source]="sources['organizationsByStatus']"
  ></av-metric-tile>

  <av-metric-tile
    [label]="'backoffice.dashboard.tiles.tenant_users.label' | translate"
    icon="group"
    [value]="facade.tenantUsersTotal().toString()"
    [caption]="'backoffice.dashboard.tiles.tenant_users.caption' | translate"
    [state]="facade.tenantUsersState()"
    [note]="facade.canReadTenantUsers() ? '' : (restrictedHint | translate)"
    [source]="sources['users']"
  ></av-metric-tile>

  <av-metric-tile
    [label]="'backoffice.dashboard.tiles.operators.label' | translate"
    icon="admin_panel_settings"
    [value]="facade.operatorsTotal().toString()"
    [caption]="'backoffice.dashboard.tiles.operators.caption' | translate"
    [state]="facade.operatorsState()"
    [note]="facade.canReadOperators() ? '' : (restrictedHint | translate)"
    [source]="sources['systemUsers']"
  ></av-metric-tile>

  <av-metric-tile
    [label]="'backoffice.dashboard.tiles.subscriptions.label' | translate"
    icon="receipt_long"
    [value]="facade.subscriptionsTotal().toString()"
    [caption]="'backoffice.dashboard.tiles.subscriptions.caption' | translate"
    [state]="facade.plansState()"
    [source]="sources['plans']"
  ></av-metric-tile>

  <av-metric-tile
    [label]="'backoffice.dashboard.tiles.revenue.label' | translate"
    icon="payments"
    [value]="(facade.monthlyRevenue() | number: '1.2-2') + ' ' + currencyLabel()"
    [caption]="'backoffice.dashboard.tiles.revenue.caption' | translate"
    [state]="facade.revenueState()"
    [note]="(revenueNote() || currencyNote()) | translate"
    [source]="sources['planSubscribers']"
  ></av-metric-tile>
</section>

<section class="av-card p-4 mt-3 d-flex flex-column gap-3">
  <div class="d-flex flex-column gap-1">
    <h2 class="av-section-title m-0">{{ 'backoffice.dashboard.revenue.title' | translate }}</h2>
    <p class="av-section-hint m-0">{{ 'backoffice.dashboard.revenue.hint' | translate }}</p>
    <span class="av-source">{{ sources['planSubscribers'] }} · {{ sources['markets'] }}</span>
  </div>

  <av-plan-revenue-table
    [rows]="facade.revenues()"
    [state]="facade.revenueState()"
    [currency]="facade.currency()"
  ></av-plan-revenue-table>
</section>

<section class="av-card p-4 mt-3 d-flex align-items-start gap-3">
  <mat-icon class="trend-icon" aria-hidden="true">query_stats</mat-icon>

  <div class="d-flex flex-column gap-1">
    <h2 class="av-section-title m-0">{{ 'backoffice.dashboard.trends.title' | translate }}</h2>
    <p class="av-section-hint m-0">{{ trendReason | translate }}</p>
  </div>
</section>
